export const parseFormattedNumber = (
  value: string | number
): number | string => {
  if (value === '') return '';

  const cleanValue = value.toString().replace(/,/g, '');
  const regex = /^(\d+(\.\d+)?)([KMB])?$/i;
  const match = cleanValue.match(regex);

  if (!match) return Number.NaN;

  const number = Number.parseFloat(match[1]);
  const suffix = match[3]?.toUpperCase();

  switch (suffix) {
    case 'B':
      return number * 1_000_000_000;
    case 'M':
      return number * 1_000_000;
    case 'K':
      return number * 1_000;
    default:
      return number;
  }
};

const THOUSANDS_GROUP_SIZE = 3;

export const formatWithThousandSeparator = (value: string | number): string => {
  const stringValue = value.toString();
  const [integerPart, decimalPart] = stringValue.split('.');
  const isNegative = integerPart.startsWith('-');
  const digits = isNegative ? integerPart.slice(1) : integerPart;

  let grouped = '';

  for (let i = digits.length - 1, count = 0; i >= 0; i--, count++) {
    if (count > 0 && count % THOUSANDS_GROUP_SIZE === 0) {
      grouped = `,${grouped}`;
    }
    grouped = digits[i] + grouped;
  }

  const signed = isNegative ? `-${grouped}` : grouped;

  return decimalPart === undefined ? signed : `${signed}.${decimalPart}`;
};

const formatWithSuffix = (
  value: number,
  divisor: number,
  suffix: string
): string => {
  const divided = value / divisor;
  const decimalPart = divided.toString().split('.')[1];

  return decimalPart && decimalPart[0] !== '0'
    ? `${divided.toFixed(1)}${suffix}`
    : `${divided.toFixed(0)}${suffix}`;
};

export const formatNumberWithSuffix = (value: number): string => {
  if (value >= 1_000_000_000) {
    return formatWithSuffix(value, 1_000_000_000, 'B');
  } else if (value >= 1_000_000) {
    return formatWithSuffix(value, 1_000_000, 'M');
  } else if (value >= 1_000) {
    return formatWithSuffix(value, 1_000, 'K');
  }

  return formatWithThousandSeparator(value);
};
